import { isDate, parseISO, format, getHours } from "date-fns";
import { formatInTimeZone, toZonedTime } from "date-fns-tz";
import {
  DEFAULT_TIMEZONE,
  LIGHT_THEME_TIME_FROM,
  LIGHT_THEME_TIME_TO,
} from "../Constants/constant";
import { de } from "date-fns/locale";

const DEFAULT_FORMAT_STR = "P, HH:mm 'Uhr'";

/**
 * Format a date range in a given timezone (default: Europe/Berlin).
 * Returns a formatted string or null if validation fails.
 */
export function formatDateRangeInTZ(
  startDate,
  endDate,
  formatStr = DEFAULT_FORMAT_STR,
  timeZone = DEFAULT_TIMEZONE,
  showOnlyDE = false
) {
  if (!startDate || !endDate) return null;

  const startParsed =
    typeof startDate === "string" ? parseISO(startDate) : startDate;
  const endParsed = typeof endDate === "string" ? parseISO(endDate) : endDate;

  if (!isDate(startParsed) || !isDate(endParsed)) return null;

  if (startParsed >= endParsed) return null;

  const startInTZ = toZonedTime(startParsed, timeZone);
  const endInTZ = toZonedTime(endParsed, timeZone);

  let startFormatted = "";
  let endFormatted = "";
  if (showOnlyDE) {
    startFormatted = format(startInTZ, formatStr, { locale: de });
    endFormatted = format(endInTZ, formatStr, { locale: de });
  } else {
    startFormatted = formatInTimeZone(startParsed, timeZone, formatStr);
    endFormatted = formatInTimeZone(endParsed, timeZone, formatStr);
  }

  return `${startFormatted} – ${endFormatted}`;
}

// export function getInitialTheme() {
//   const now = new Date();
//   const seconds = now.getSeconds();
//   return (Math.floor(seconds / 30) % 2 === 0) ? 'light' : 'dark';
// }

/**
 * Get current theme based on local time.
 * Returns 'dark' if time is between 17:00 and 06:00, else 'light'
 */
export function getInitialTheme() {
  const hour = getHours(new Date()); // user's local time
  return hour >= LIGHT_THEME_TIME_TO || hour < LIGHT_THEME_TIME_FROM
    ? "dark"
    : "light";
}
